// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-style-comment-reply[data-v-3cbde247]{margin-left:15px;padding:5px}\n", ""]);
// Exports
module.exports = exports;
